
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/how-to-write-a-work-sample-or-case-study-for-your-portfolio",
      function () {
        return require("private-next-pages/resources/how-to-write-a-work-sample-or-case-study-for-your-portfolio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/how-to-write-a-work-sample-or-case-study-for-your-portfolio"])
      });
    }
  